import { render, staticRenderFns } from "./VasionLegallyBindingConsentModal.vue?vue&type=template&id=8325f006&scoped=true&"
import script from "./VasionLegallyBindingConsentModal.vue?vue&type=script&lang=js&"
export * from "./VasionLegallyBindingConsentModal.vue?vue&type=script&lang=js&"
import style0 from "./VasionLegallyBindingConsentModal.vue?vue&type=style&index=0&id=8325f006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8325f006",
  null
  
)

export default component.exports